<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_iv"></a>© 2008 The Johns Hopkins University Press<br/>All rights reserved. Published 2008<br/>Printed in the United States of America on acid-free paper<br/>2  4  6  8  9  7  5  3  1</p>
<p class="copyright">The Johns Hopkins University Press<br/>2715 North Charles Street<br/>Baltimore, Maryland 21218-4363<br/><span class="weblink"><a class="nounder" href="http://www.press.jhu.edu" target="_blank">www.press.jhu.edu</a></span></p>
<p class="copyright"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="copyright1">Goldsmith, Jeff Charles.<br/>     The long baby boom : an optimistic vision for a graying generation / Jeff Goldsmith.<br/>        p. cm.<br/>     Includes bibliographical references and index.<br/>     ISBN-13: 978-0-8018-8851-9 (hardcover : alk. paper)<br/>     ISBN-10: 0-8018-8851-4 (hardcover : alk. paper)</p>
<p class="copy2">1. Baby boom generation—United States—Psychology.  2. Baby<br/>boom generation—Retirement—United States.  3. Baby boom<br/>generation—Health and hygiene—United States.  4. Baby boom<br/>generation—United States—Social conditions—21st century.<br/>5. Health attitudes—Age factors—United States.  6. Medical care—<br/>United States—Forecasting.  I. Title.<br/>     HQ1063.2.U6G654 2008<br/>     305.2—dc22                                                          2007041649</p>
<p class="copy3">A catalog record for this book is available from the British Library.</p>
<p class="copyright1"><em>Special discounts are available for bulk purchases of this book. For more information, please contact Special Sales at 410-516-6936 or <a class="nounder" href="mailto:specialsales@press.jhu.edu">specialsales@press.jhu.edu</a>.</em></p>
<p class="noindent">The Johns Hopkins University Press uses environmentally friendly book materials, including recycled text paper that is composed of at least 30 percent post-consumer waste, whenever possible. All of our book papers are acid-free, and our jackets and covers are printed on paper with recycled content.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?11df170d